exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hacked input:-ms-input-placeholder,.teacher-remote .hacked-remote input:-ms-input-placeholder{font-size:.45em}.hacked input::placeholder,.teacher-remote .hacked-remote input::placeholder{font-size:.45em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/session/presentation/components/hacked.scss
// module id = 1309
// module chunks = 2